import { type PropsWithChildren } from 'react'

import Link from 'component/block/link'
import { useRecentSearchStore } from 'store/recent-search'
import { TabKey, type ISearchHistoryV2 } from 'type/search'
import cn from 'util/cn'

interface ISearchLink {
  item: ISearchHistoryV2
  className?: string
}

function iife<T>(fn: () => T): T {
  return fn()
}

const SearchLink = (props: PropsWithChildren<ISearchLink>) => {
  const { item, className, children } = props

  const addSearch = useRecentSearchStore(state => state.addSearch)

  const href = iife(() => {
    switch (item.type) {
      case 'user': {
        return `/${item.uid}`
      }
      case 'community': {
        return `/community/${item.id}`
      }
      case 'keyword': {
        const searchParams = new URLSearchParams()
        searchParams.set('q', item.keyword)
        searchParams.set('tab', TabKey.Spot)
        return `/search?${searchParams.toString()}`
      }
      default:
        return ''
    }
  })

  return (
    <Link
      href={href}
      className={cn(
        'block px-[16px] py-[6px] hover:bg-background-2nd',
        className
      )}
      onClick={() => addSearch(item)}
    >
      {children}
    </Link>
  )
}

export default SearchLink
